// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__3J9ne","dragIcon":"Choice_dragIcon__309BH","left":"Choice_left__2RzK3","input":"Choice_input__3pzdC"};